var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"text-dark mb-0"},[_vm._v(_vm._s(_vm.action))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"font-size":"36px"}},[_c('i',{staticClass:"far fa-spinner fa-spin text-secondary"})])
}]

export { render, staticRenderFns }